export class ResearchDisplaySettiings {
    constructor() {
        this.showDemographics = true;
        this.showExistingSolutions = true;
        this.showCuriosity = true;
        this.showCorruption = true;
        this.showExtraNotes = true;
    }
}
